module.exports = __webpack_public_path__ + "img/auth-phone.09865502.png";